/* Customers.tsx
	Page affichant la liste des clients
	Utilise TiersCrudCard filtré sur le type 'CLI'
*/

// Import React
import React from 'react';

// Import FontAwesome
import {
	faBuilding,
	faFileContract,
	faLocationDot,
	faPhone,
} from '@fortawesome/free-solid-svg-icons';

// Import Router
import { useNavigate } from 'react-router-dom';

// Import Feature
import { TiersCrudCard } from 'features/tiers';

// Import Layout
import PageHeader from 'layout/PageHeader';

// Import Communs
import { MainButton } from 'common';

// Customers page component
const Customers: React.FC = () => {
	const navigate = useNavigate();

	return (
		<div className="min-h-screen bg-gray-100 p-6">
			{/* Titre de page */}
			<PageHeader
				icon={faBuilding}
				title="Clients"
				subtitle="Gérez les clients de votre entreprise"
			/>
			<TiersCrudCard tiersType="CLI" size="lg" hideReturn className="mt-6" />
			{/* Actions rapides vers les domaines liés aux clients */}
			<div className="max-w-6xl mx-auto flex justify-end gap-2 mt-4">
				<MainButton
					label="Adresses"
					onClick={() => navigate('/app/addresses')}
					size="lg"
					icon={faLocationDot}
				/>
				<MainButton
					label="Contacts"
					onClick={() => navigate('/app/contacts')}
					size="lg"
					icon={faPhone}
				/>
				<MainButton
					label="Devis"
					onClick={() => navigate('/app/quotes')}
					size="lg"
					icon={faFileContract}
				/>
			</div>
		</div>
	);
};

export default Customers;
